import { Injectable } from '@angular/core';
import { AppService } from './app.service';
import { MessageService, MessageOnOnline, MessageOnOffline } from './message.service';

@Injectable({
  providedIn: 'root'
})
export class OnlineOfflineService {
  isOnline = true;
  hasStart = false;
  constructor(
    private messageService: MessageService
  ) {
    window['isAppOnline'] = true;
    if (AppService.isIOS()) {
      setTimeout(() => {
        (<any>window).cordova.plugins.ttsplugin.coolMethod(
          ['deviceversion'],
          (s) => {
            // alert(s);
            console.log('deviceversion:' + s);
            if (Number(s) < 13) {
              this.listenForOnlineOfflineEvent();
            } else {
              this.start();
            }
          }, err => {
          }
        );
      }, 3000);
    } else if(AppService.isAndroid()){
      setTimeout(() => {
        this.start();
        }, 3000);
    } else {
      this.listenForOnlineOfflineEvent();
    }
  }

  private updateOnlineStatus() {
    if (navigator && navigator.onLine) {
      this.onOnline();
    } else if (navigator && !navigator.onLine) {
      this.onOffline();
    }
  }

  private listenForOnlineOfflineEvent() {
    console.log('listenForOnlineOfflineEvent');
    window.addEventListener('online',  this.updateOnlineStatus.bind(this));
    window.addEventListener('offline', this.updateOnlineStatus.bind(this));
  }

  public start() {
    if ((AppService.isIOS() || AppService.isAndroid()) && !this.hasStart) {
      this.hasStart = true;
      setInterval(() => {
        (<any>window).cordova.plugins.ttsplugin.coolMethod(
          ['network'],
          (s) => {
            if (s == 'online') {
              if (!this.isOnline) {
                this.onOnline();
              }
            } else {
              if (this.isOnline) {
                this.onOffline();
              }
            }
          }, err => {
          }
        );
      }, 3000);
    }
  }

  public onOnline() {
    // if(AppService.isIOS()) {
    //   this.settingsService.setSelectedVoiceType('prem');
    // }
    this.isOnline = true;
    console.log("onOnline");
    window['isAppOnline'] = true;
    this.messageService.sendMessage({ name: MessageOnOnline });
  }

  public onOffline() {
    this.isOnline = false;
    console.log("onOffline");
    window['isAppOnline'] = false;
    this.messageService.sendMessage({ name: MessageOnOffline });
  }


}
